import { CertificadoService } from './../services/certificado.service';
import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import DadosCertificadoModel from '../model/dados-certificado.model';
import { HttpUtilService } from '../services/http-util.service';
import DadosOutorganteModel from '../model/dados-outorgante.model';
import { Subscription } from 'rxjs';
import { OutorgaService } from '../services/outorga.service';
import { API_CNS_PORTAL } from '../app.api'
import Utils from '../utils/utils';

@Component({
  selector: 'app-topo',
  templateUrl: './topo.component.html',
  styleUrls: ['./topo.component.css']
})
export class TopoComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public dadosCertificado: DadosCertificadoModel;
  @Input() public dadosOutorgante: DadosOutorganteModel;

  public inscricao: string;
  public razaoSocial: string;
  public labelNome: string;
  public labelcpfCnPjCei: string;
  public cpf: string;
  public isCnpj: boolean;
  public isCei: boolean;
  public isCpf: boolean;
  public outorgado;

  //outorgante
  public labelInscricaoOutorgante: string;
  public cpfOutorgante: string;
  public labelNomeOutorgante: string;
  public labelTipoInscricao: string;
  public inscricaoOutorgante: string;
  public isCeiOutorgante: boolean;
  public isCpfOutorgante: boolean;
  public isCnpjOutorgante: boolean;

  public certificados;
  public tipoInscricao;
  sub: Subscription;

  constructor(
    public httpUtilService: HttpUtilService,
    private outorgaService: OutorgaService) { }

  ngOnInit() {
    this.outorgadoSubscribe();
    this.atualizarOutorgado();
  }

  ngOnChanges() {
    this.atualizarOutorgado();
  }
  
  private async atualizarOutorgado(){
    
    this.tipoInscricao = this.httpUtilService.obterTipoInscricao();
    this.inscricao = Utils.formatarIncricao(this.httpUtilService.obterInscricao(), this.tipoInscricao);
    if (this.dadosCertificado) {
      await this.popularOutorgado();
    }
  }


  private async popularOutorgado() {

    new Promise((resolve, reject) => {
      if (this.dadosCertificado) {
        this.cpf =  Utils.mascaraInscricao(this.dadosCertificado.nu_cpf.toString() ,"3");
        this.labelNome = this.isCnpj ? 'Razão Social' : 'Nome';
        this.dadosCertificado.de_nome_comum = this.dadosCertificado.de_nome_comum;
        this.dadosCertificado.no_responsavel = this.dadosCertificado.no_responsavel;
        this.retornarLabelcpfCnPjCei(this.tipoInscricao);
        resolve(this.dadosCertificado);
      }
      else {
        resolve(undefined);
      }
    });
  }
  
  private popularOutorgante() {
    if ( this.dadosOutorgante) {
      this.cpfOutorgante = Utils.mascaraInscricao(this.dadosOutorgante.cpf.toString(),"3");
       this.labelNomeOutorgante =  this.isCnpj ? 'Razão Social' : 'Nome';
       this.dadosOutorgante.razao =   this.dadosOutorgante.razao;
       const tipo = this.dadosOutorgante.inscricao.toString().substring(0, 1);
       this.retornarLabelInscricaoOutorgante(this.dadosOutorgante.inscricao);
       this.inscricaoOutorgante = Utils.formatarIncricao(this.dadosOutorgante.inscricao.toString().substring(1), tipo);
    }
  }

  private retornarLabelcpfCnPjCei(inscricao) {
    this.isCnpj = false;
    this.isCei = false;
    this.isCpf = false;
    switch (inscricao.toString().substring(0, 1)) {
      case '1':
        this.labelcpfCnPjCei = 'CNPJ';
        this.isCnpj = true;
        break;
      case '2':
        this.labelcpfCnPjCei = 'CEI';
        this.isCei = true;
        break;
      default:
        this.labelcpfCnPjCei = 'CPF';
        this.isCpf = true;
        break;
    }
  }
    private retornarLabelInscricaoOutorgante(inscricao) {
      this.isCnpjOutorgante = false;
      this.isCeiOutorgante = false;
      this.isCpfOutorgante = false;

      switch (inscricao.toString().substring(0, 1)) {
        case '1':
          this.labelInscricaoOutorgante = 'CNPJ';
          this.isCnpjOutorgante = true;
          break;
        case '2':
          this.labelInscricaoOutorgante = 'CEI';
          this.isCeiOutorgante = true;
          break;
        default:
          this.labelInscricaoOutorgante = 'CPF';
          this.isCpfOutorgante = true;
          break;
      }
  }

  outorgadoSubscribe() {
    this.sub = this.outorgaService.getOutorgado()
    .subscribe(response => {
      if (response) {
        this.dadosOutorgante = response[2];
        this.outorgado = response[0];
         this.popularOutorgante();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }


  public redirecionaCnsPortal() {
    const token = sessionStorage.getItem('token');
    var url = API_CNS_PORTAL;
    var url = (!token) ?  API_CNS_PORTAL : API_CNS_PORTAL + "?token=" + token;
    window.location.href = url;

  }

}
